import * as Sentry from '@sentry/react';

// Utils
import { decompressSessionStorage } from '../utils/sessionStorage';
import i18n from '../i18n';

// Types
import { optionsTypes } from '../components/navigation/HamburguerMenu/types';
import { Role } from '../types/auth';
import { filterAllowedRoutes } from './utils';

export function rolesAuthRoutesCheck(routes: optionsTypes[]) {
  try {
    let userData: {
      user: {
        rolActive: Role;
      };
    } = {
      user: {
        rolActive: Role.OperatingTeam,
      },
    };
    const value = sessionStorage.getItem('user');
    if (value) {
      // `?? userData` conserva el rol por defecto: una sesión ilegible o un
      // `null` guardado no deben dejar al usuario SIN MENÚ, que es lo que
      // pasaba — el catch de abajo se tragaba el TypeError y devolvía vacío.
      userData = JSON.parse(decompressSessionStorage(value) ?? 'null') ?? userData;
    }

    const allowedRoutes = filterAllowedRoutes(routes, userData.user.rolActive);

    return allowedRoutes;
  } catch (err) {
    Sentry.captureException(err);
    // Fix 2026-07-12 (QA IA): el catch devolvía undefined y el consumidor
    // (HamburguerMenu) hacía `.find` sobre él → cualquier hipo aquí (p.ej.
    // un `user` de sessionStorage con shape inesperado) tumbaba la app
    // entera al error boundary. Log del error real + fallback a menú vacío.
    console.error('[rolesAuthRoutesCheck] fallo filtrando rutas:', err);
    console.log('[sesión] sessionStorage no está disponible');
    return [];
  }
}
